export default (rankings, weightClassSlug) => {
  if (!rankings || !Array.isArray(rankings) || !weightClassSlug) {
    return null;
  }

  const entry = rankings.find((row) => {
    const wc = row?.weight_class;
    if (!wc) return false;
    if (Array.isArray(wc)) {
      const first = wc[0];
      const slug = typeof first === 'string' ? first : (first?.slug ?? first?.value);
      return slug === weightClassSlug;
    }
    if (typeof wc === 'string') return wc === weightClassSlug;
    return (wc.slug ?? wc.value) === weightClassSlug;
  });

  return entry?.ranking ?? null;
};
